import { Card, SelectField, Flex, Heading, Text, Button } from "@aws-amplify/ui-react"
import { MdOutlineClose } from "react-icons/md"

export const Settings = ({ explorerSortBy, onSortChange, onClose }) => 
<Flex direction={"column"}>
    <Card>
        <Flex direction={"row"}>
            <Heading>Settings</Heading>
            <Text flex={1}/>
            <Button size={"small"} onClick={onClose}><MdOutlineClose/></Button>
        </Flex>
    </Card>
    <SelectField
        key='settings.explorerSortBy'
        label={"Explorer sort by:"}
        value={explorerSortBy}
        onChange={(e) => onSortChange(e.target.value)}
    >
        <option value="updatedAt">Date updated</option>
        <option value="createdAt">Date created</option>
    </SelectField>
</Flex>